<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">Movement Orders</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="confirmData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="check"
                    >Confirm</vs-button>
                    <vs-button
                        @click="cancelData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="cancel"
                    >Cancel</vs-button>
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        :to="{ name: 'movement-order-add'} "
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="filterInit"
                    >Filter</vs-button>
                    <vs-button
                        @click="exportData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="import_export"
                    >Export</vs-button>
                    <vs-button
                        @click="containerAdd = {show: true, movement_id: '', container_ids: [{no: 1, id: ''}], selected: []}"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="shopping_cart"
                    >Add To Container</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="movementOrders"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="multiple"
            ></ag-grid-vue>
            <p class="text-right"><b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }}  total entries</b></p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
        </vx-card>
        <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <vs-input
                    placeholder="Reference"
                    v-model="filter.gr_reference"
                    class="mb-4 w-full"
                />
                <v-select
                  :options="statusOption"
                  v-model="filter.status_id"
                  :reduce="option => option.value"
                  :clearable="false"
                ></v-select>
            </div>
        </vs-prompt>
        <vs-popup title="Add Picklist to Container" :active.sync="containerAdd.show">
            <div class="con-exemple-prompt">
                <vs-input
                    label="Picklist / Movement ID"
                    v-model="containerAdd.movement_id"
                    class="mb-4 w-full"
                />
                <vs-table v-model="containerAdd.selected" :data="containerAdd.container_ids" hoverFlat multiple>
                    <template slot="thead">
                        <vs-th style="min-width: 70px; width: 70px">No</vs-th>
                        <vs-th>Container ID</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
                            <vs-td>
                                <vs-input class="w-full" :value="index + 1" disabled/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.id"/>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <vs-row class="flex justify-between mt-5">
                    <div>
                        <vs-button
                            class="mr-4"
                            color="primary"
                            type="flat"
                            @click="removeContainer"
                            :disabled="containerAdd.selected.length < 1"
                        >Remove Container</vs-button>
                        <vs-button
                            class="mr-4"
                            color="primary"
                            type="filled"
                            @click="containerAdd.container_ids.push({ id: '' })"
                        >Add Container</vs-button>
                    </div>
                    <div>
                        <vs-button
                            class="mr-4"
                            color="primary"
                            type="filled"
                            @click="addToContainer"
                        >Save</vs-button>
                    </div>
                </vs-row>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from "vue-select";
import FileSaver from "file-saver";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            containerAdd: {
                show: false,
                movement_id: '',
                container_ids: [
                    {
                        no: 1,
                        id: '',
                    }
                ],
                selected: []
            },
            searchQuery: "",
            gridOptions: {},
            movementOrders: [],
            maxPageNumbers: 7,
            gridApi: null,
            isLoading: false,
            showFilter: false,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            filter: {
                gr_reference: "",
                status_id: 1
            },
            statusOption: [
                {
                    value: 1,
                    label: 'Open'
                },
                {
                    value: 2,
                    label: 'Confirmed'
                },
                {
                    value: 3,
                    label: 'Cancelled'
                }
            ],
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        refreshData() {
            this.fetchData();
        },
        fetchData() {
            this.isLoading = true;
            this.$http
                .post("inventories/movementorder", this.filter)
                .then(res => {
                    this.movementOrders = res.data.data;
                    this.totalPage = res.data.last_page;
                    this.dataTotal = res.data.total;
                    this.dataFrom = res.data.from;
                    this.dataTo = res.data.to;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                    return;
                });
        },
        exportData() {
            this.isLoading = true;
            this.$http
                .get("inventories/movementorder/report/download_excel", {
                    responseType: "blob"
                })
                .then(res => {
                    this.isLoading = false;
                    FileSaver.saveAs(res.data, "mo_export.xlsx");
                });
        },
        confirmData() {
            const selectedData = this.gridApi.getSelectedRows();
            if (selectedData.length <= 0) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "No data selected"
                });
            } else {
                this.isLoading = true;
                const dataSend = [];
                selectedData.map(item => {
                    dataSend.push({ id: item.id });
                });

                this.$http
                    .post("putaway/confirmputaway", {
                        list_putaway: JSON.stringify(dataSend),
                        type: "MO"
                    })
                    .then(res => {
                        this.isLoading = false;
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: "Confirmed successfully"
                        });
                        this.refreshData();
                    })
                    .catch(error => {
                        const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                        this.isLoading = false;
                        this.$vs.notify({
                            color: "danger",
                            title: "Error saving",
                            iconPack: "feather",
                            icon: "icon-x",
                            text: message
                        });
                    });
            }
        },
        cancelData() {
            const selectedData = this.gridApi.getSelectedRows();
            if (selectedData <= 0) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "No data selected"
                });
            } else {
                this.isLoading = true;
                const dataSend = [];
                selectedData.map(item => {
                    dataSend.push({ id: item.id });
                });

                this.$http
                    .post("putaway/cancelputaway", {
                        list_putaway: JSON.stringify(dataSend)
                    })
                    .then(res => {
                        this.isLoading = false;
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: "Cancelled successfully"
                        });
                        this.refreshData();
                    })
                    .catch(error => {
                        const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                        this.isLoading = false;
                        this.$vs.notify({
                            color: "danger",
                            title: "Error saving",
                            iconPack: "feather",
                            icon: "icon-x",
                            text: message
                        });
                    });
            }
        },
        filterData() {
            this.fetchData();
        },
        filterInit() {
            this.showFilter = true;
        },
        addToContainer() {
            let error = false
            let ids = []

            if(!this.containerAdd.movement_id) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: `Movement ID is empty`
                });

                error = true
            }
            
            this.containerAdd.container_ids.map((item, index) => {
                if(!item.id) {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: `Line ${index + 1} - Empty container ID`
                    });

                    error = true
                }
            })

            if(error) {
                return false
            }

            const data = {
                movement_id: this.containerAdd.movement_id,
                container_ids: this.containerAdd.container_ids.map(item => item.id)
            }

            this.isLoading = true
            this.$http.post('inventories/movementorder/addtocontainer', data)
            .then(res => {
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: `Added picklist ${data.movement_id} to ${data.container_ids.length} container`
                });

                this.containerAdd.show = false
                this.isLoading = false
            })
            .catch(error => this.handleError(error))
        },
        removeContainer() {
            let indexes = []
            this.containerAdd.container_ids.map((item, index) => {
                item.no = index + 1
            })

            this.containerAdd.selected.map(selected => {
                this.containerAdd.container_ids.map((container, index) => {
                    if(selected.no == container.no) {
                        indexes.push(index)
                    }
                })
            })

            this.containerAdd.selected = []

            indexes.sort((a, b) => b - a)
            indexes.map(i => {
                this.containerAdd.container_ids.splice(i, 1)
            })
        }
    },
    mounted() {
        this.showFilter = true;
        this.gridApi = this.gridOptions.api;
        this.$vs.loading.close()
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Movement Date",
                field: "movement_date",
                width: 120,
                checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                headerCheckboxSelection: true
            },
            {
                headerName: "Transaction Source",
                field: "transaction_source",
                width: 120
            },
            {
                headerName: "Reference",
                field: "reference",
                width: 120
                // pinned: 'left'
            },
            {
                headerName: "Client ID",
                width: 120,
                field: "client_code"
            },
            {
                headerName: "Warehouse ID",
                field: "warehouse.warehouses_code",
                width: 120
            },
            {
                headerName: "Product ID",
                field: "product_code",
                width: 120
            },
            {
                headerName: "Description",
                field: "description",
                width: 120
            },
            {
                headerName: "Pack ID",
                field: "pack_id",
                width: 120
            },
            {
                headerName: "Batch",
                field: "batch",
                width: 120
            },
            {
                headerName: "Exp. Date",
                field: "expired_date",
                width: 120
            },
            {
                headerName: "Base Qty",
                field: "base_qty",
                width: 120
            },
            {
                headerName: "Base UoM",
                field: "base_uom_name",
                width: 120
            },
            {
                headerName: "Stock Type",
                field: "stock_type_name",
                width: 120
            },
            {
                headerName: "Src. Location Type",
                field: "source_location_type",
                width: 120
            },
            {
                headerName: "Src. Location ID",
                width: 120,
                cellRenderer: params => {
                    if (params.data.source_location_code) {
                        return params.data.source_location_code;
                    }
                    else {
                        return params.data.source_location_id;
                    }
                }
            },
            {
                headerName: "Src. Storage Unit",
                field: "source_storage_unit",
                width: 120
            },
            {
                headerName: "Dest. Location Type",
                field: "dest_location_type",
                width: 120
            },
            {
                headerName: "Dest. Location ID",
                field: "dest_location_code",
                width: 120
            },
            {
                headerName: "Dest. Storage Unit",
                field: "dest_storage_unit",
                width: 120
            },
            {
                headerName: "Status",
                field: "status_name",
                width: 120
            }
        ];

        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>